import { all, call, spawn } from 'redux-saga/effects';

import { watchApiCallsSaga } from 'src/redux/api/saga';
import { watchCustomLoginSaga } from 'src/redux/auth/sagas';
import {
  watchCommentApiCallsSaga,
  watchCommentReplyApiCallsSaga,
  watchRestoreCommentApiCallsSaga,
} from 'src/redux/comments/saga';
import { watchIconsDetailsSaga } from 'src/redux/icons/saga';
import {
  watchLockInfographicsSaga,
  watchUnlockInfographicsSaga,
  watchUpdateInfographicsSaga,
} from 'src/redux/infographics/saga';
import narrativeSaga, {
  watchCancelNarrativeEditingSaga,
  watchExtraNarrativeSaga,
  watchGetNarrativeHistorySaga,
  watchLockNarrativeSaga,
  watchMultiNarrativeSaga,
  watchNarrativeSaga,
  watchRevertNarrativeHistorySaga,
} from 'src/redux/narrative/saga';
import { watchRepeatedActionSaga } from 'src/redux/pdf/saga';
import getPublicationStatusSaga from 'src/redux/publicationStatus/saga';
import {
  watchAcrReportStateTransitionSaga,
  watchChangeDatePickerSaga,
} from 'src/redux/reports/saga';
import {
  watchRequestDataInfoBoxSaga,
  watchUpdateReviewStateSaga,
} from 'src/redux/review/saga';
import {
  watchPostSectionTitleSaga,
  watchRequestDataSourcesRefreshSaga,
  watchRequestExtraSectionSaga,
  watchUpdateDataNotesSaga,
} from 'src/redux/sections/saga';
import setSubtitleSaga from 'src/redux/subtitle/saga';
import { watchUpdateUserSettingsSaga } from 'src/redux/userSettings/saga';

const resilientSagas = [
  narrativeSaga,
  getPublicationStatusSaga,
  setSubtitleSaga,
];

export default function* rootSaga() {
  yield all([
    ...resilientSagas.map(saga =>
      spawn(function* () {
        while (true) {
          try {
            yield call(saga);
            break;
          } catch (e) {
            console.error(e);
          }
        }
      }),
    ),
    watchApiCallsSaga(),
    watchCommentApiCallsSaga(),
    watchCommentReplyApiCallsSaga(),
    watchRestoreCommentApiCallsSaga(),
    watchRequestExtraSectionSaga(),
    watchRequestDataSourcesRefreshSaga(),
    watchRequestDataInfoBoxSaga(),
    watchChangeDatePickerSaga(),
    watchAcrReportStateTransitionSaga(),
    watchUpdateDataNotesSaga(),
    watchPostSectionTitleSaga(),
    watchCancelNarrativeEditingSaga(),
    watchLockNarrativeSaga(),
    watchGetNarrativeHistorySaga(),
    watchRevertNarrativeHistorySaga(),
    watchUpdateReviewStateSaga(),
    watchUpdateUserSettingsSaga(),
    watchRepeatedActionSaga(),
    watchUpdateInfographicsSaga(),
    watchLockInfographicsSaga(),
    watchUnlockInfographicsSaga(),
    watchIconsDetailsSaga(),
    watchNarrativeSaga(),
    watchMultiNarrativeSaga(),
    watchExtraNarrativeSaga(),
    watchCustomLoginSaga(),
  ]);
}
